import { Injectable } from '@angular/core';
import { CommentTextPart, MentionUser } from 'src/app/shared/interface/comment-mention';

@Injectable({
  providedIn: 'root'
})
export class MentionUtilsService {

  syncMentions(text: string, mentions: MentionUser[]): MentionUser[] {
    return mentions.filter((x) => (text || '').includes(`@${x.name}`));
  }

  splitMentions(text: string, names: string[]): CommentTextPart[] {
    const validNames = [...new Set(names.filter((x) => x))].sort((a, b) => b.length - a.length);
    if (!text || !validNames.length) {
      return [{ text: text || '', isMention: false }];
    }
    const pattern = new RegExp(`(@(?:${validNames.map((x) => this.escapeRegExp(x)).join('|')}))`, 'g');
    return text.split(pattern)
      .filter((x) => x)
      .map((x) => ({ text: x, isMention: validNames.some((name) => x == `@${name}`) }));
  }

  private escapeRegExp(value: string): string {
    return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }
}
